import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderAdHocAttachments(orderId) {
  const response = await $.soap({
    body: {
      GetOrderAdHocAttachments: {
        $xmlns: 'http://dla.mil/ems/bpm/attachment',
        OrderID: orderId
      }
    },
    blueprintArrays: ['GetOrderAdHocAttachmentsResponse.Attachments.Attachment'],
    blueprint: {
      attachments: [
        '$..Attachment',
        {
          id: '$..ID',
          objectTypeId: '$..ObjectTypeID',
          objectId: '$..ObjectID',
          documentTypeId: '$..DocumentTypeID',
          fileName: '$..FileName',
          uploadedBy: '$..UploadedBy',
          uploadedOn: '$..UploadedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.attachments;
}
